<template>
  <v-flex
    v-if="getSheetDescriptionQuestions.hasOwnProperty('family_introduction')"
    id="familyIntroduction"
    class="question"
  >
    <h2
      class="header"
      :class="{ required: hint }"
    >
      {{ getSheetDescriptionQuestions.family_introduction.label }}
    </h2>
    <v-layout
      justify-space-between
      row
      wrap
    >
      <v-flex
        v-if="hint"
        xs12
        :sm4="hint"
      >
        <div class="content">
          <p
            v-for="(text, index) in getSheetDescriptionQuestions.family_introduction.text"
            :key="index"
            class="mb-0"
          >
            {{ text }}
          </p>
        </div>
      </v-flex>
      <v-flex
        xs12
        :sm8="hint"
      >
        <div class="content">
          <v-layout
            row
            wrap
            :justify-end="!xsOnly"
            :justify-center="xsOnly"
          >
            <familyAvatar
              v-for="(person, index) in familyList"
              :key="index"
              :person="person"
            />
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import familyAvatar from '@/components/widgets/description/familyAvatar';
import { mapGetters } from 'vuex';

export default {
    name: 'FamilyIntroduction',
    components: { familyAvatar },
    props: {
        familyGuide: {
            default: () => {
                return [];
            }
        },
        relationResource: {
            default: () => {
                return [];
            }
        },
        ageResource: {
            default: () => {
                return [];
            }
        },
        changedNames: {
            default: () => {
                return [];
            }
        },
        hint: {
            default: true
        }
    },
    computed: {
        ...mapGetters('sheet', ['getSheetDescriptionQuestions']),
        xsOnly () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        familyList () {
            const list = [];
            this.familyGuide.representatives.forEach((el) => {
                const tmp = { ...el };

                tmp.relation = this.relationResource.find((e) => {
                    return e.id === tmp.relation;
                });
                if (tmp.relation != null) {
                    tmp.relation = tmp.relation.description;
                }
                tmp.ageOption = this.ageResource.find((e) => {
                    return e.id === tmp.ageOption;
                });
                if (tmp.ageOption != null) {
                    tmp.ageOption = tmp.ageOption.description;
                }

                const changedName = this.changedNames.find((e) => {
                    return e.id === el.id;
                });
                if (changedName) {
                    list.push({ ...tmp, changedName: changedName.newName });
                }
            });

            return list;
        }
    }
};
</script>

<style scoped></style>
